// The official JR access key is provisioned separately and must be added here
// using the same source-constant process as the other operator configurations.
// If the key has not yet been supplied, this constant must remain empty so the
// predicate fails closed.
const JR_ACCESS_KEY = "pdvlonj1ljss7vf85kabxnkm";

const JR_OPERATOR = Object.freeze({
  label: "JR",
  company: "jr",
  accessKey: JR_ACCESS_KEY,
});

const createJrAccessPolicy = (configuredAccessKey = JR_ACCESS_KEY) => ({
  isJrAccessKey: (accessKey) =>
    Boolean(configuredAccessKey) && accessKey === configuredAccessKey,
});

const isJrAccessKey = (accessKey, configuredAccessKey = JR_ACCESS_KEY) =>
  createJrAccessPolicy(configuredAccessKey).isJrAccessKey(accessKey);

const isJrOperator = isJrAccessKey;

export {
  JR_ACCESS_KEY,
  JR_OPERATOR,
  createJrAccessPolicy,
  isJrAccessKey,
  isJrOperator,
};
